import { Route } from '@angular/router';

export const appRoutes: Route[] = [
    {
        path: '',
        loadComponent: () => import('../containers/home/home-container.component').then(m => m.HomeContainerComponent),
        children: [
            {
                path: '',
                loadComponent: () =>
                    import('../containers/create-order/create-order-container.component').then(
                        m => m.CreateOrderContainerComponent,
                    ),
            },
            {
                path: 'view-order/:id',
                loadComponent: () =>
                    import('../containers/view-order/view-order-container.component').then(
                        m => m.ViewOrderContainerComponent,
                    ),
            },
        ],
    },
    {
        path: '**',
        redirectTo: '',
        pathMatch: 'full',
    },
];
